module.exports = __webpack_public_path__ + "img/goBack.919548f3.png";